import { WagoApiClient } from '@shared/service/wago-api.client';
import { forkJoin, Observable } from 'rxjs';
import { PropertyTemplates, PropertyTemplateVO } from '@project/components/article/model/vo/property-template-vo';
import { HttpParams } from '@angular/common/http';
import { PropertyUtils } from '@article/util/property-utils';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PropertyTemplateService {
  private readonly getAllConnectionPropertyTemplatesUrl: string = 'property/connection/propertytemplates';
  private readonly getAllBehaviorPropertyTemplatesUrl: string = 'property/behavior/propertytemplates';
  private readonly getAllPlausiPropertyTemplatesUrl: string = 'property/plausi/propertytemplates';
  private readonly saveConnectionPropertyTemplateUrl: string = 'property/savetemplate';
  private readonly deleteConnectionPropertyTemplateUrl: string = 'property/deletetemplate';
  private readonly overwriteConnectionPropertyTemplateUrl: string = 'property/overwritetemplate';
  private readonly isPropertyInUseUrl: string = 'property/is-used';

  constructor(private wagoApiClient: WagoApiClient) {}

  public getAllPropertyTemplates(): Observable<PropertyTemplates> {
    const observables = [this.getAllConnectionPropertyTemplates(), this.getAllBehaviorPropertyTemplates(), this.getAllPlausiPropertyTemplates()];
    return forkJoin(observables).pipe(
      map((propertyTemplates: PropertyTemplateVO[][]) => {
        return {
          connectionProperties: propertyTemplates[0].filter((p) => !PropertyUtils.isInternalConnectionPropertyName(p.propertyName)),
          behaviorProperties: propertyTemplates[1],
          plausiProperties: propertyTemplates[2],
        };
      })
    );
  }

  public getAllConnectionPropertyTemplates(): Observable<PropertyTemplateVO[]> {
    return this.wagoApiClient.get(this.getAllConnectionPropertyTemplatesUrl);
  }

  public getAllBehaviorPropertyTemplates(): Observable<PropertyTemplateVO[]> {
    return this.wagoApiClient.get(this.getAllBehaviorPropertyTemplatesUrl);
  }

  public getAllPlausiPropertyTemplates(): Observable<PropertyTemplateVO[]> {
    return this.wagoApiClient.get(this.getAllPlausiPropertyTemplatesUrl);
  }

  public savePropertyTemplate(propertyTemplate: PropertyTemplateVO): Observable<void> {
    return this.wagoApiClient.post(this.saveConnectionPropertyTemplateUrl, propertyTemplate);
  }

  public deletePropertyTemplate(propertyTemplate: PropertyTemplateVO): Observable<void> {
    return this.wagoApiClient.post(this.deleteConnectionPropertyTemplateUrl, propertyTemplate);
  }

  public overwritePropertyTemplate(propertyTemplate: PropertyTemplateVO, previousName: String = ''): Observable<void> {
    const dto: any = {
      propertyType: propertyTemplate.propertyType,
      propertyName: propertyTemplate.propertyName,
      propertyValueTypes: propertyTemplate.propertyValueTypes,
      propertyDescription: propertyTemplate.propertyDescription,
      previousPropertyName: previousName,
    };
    return this.wagoApiClient.post(this.overwriteConnectionPropertyTemplateUrl, dto);
  }

  public isPropertyInUse(propertyType: string, propertyName: string): Observable<boolean> {
    const httpParams: HttpParams = new HttpParams().set('propertyType', propertyType).set('propertyName', propertyName);
    return this.wagoApiClient.get(this.isPropertyInUseUrl, { params: httpParams });
  }
}
